export class User {
  constructor(public id: number = 0,
              public username: string = '',
              public first_name: string = '',
              public fathers_name: string = '',
              public last_name: string = '',
              public email: string = '',
              public password: string = '',
              public birth_date: Date = new Date(),
              public phone: string = '',
              public personal_number: string = '',
              public notes: string = '',
              public group: Group = new Group(),
  ) {
  }

  public static getFullName(user: User) {
    return `${user.first_name} ${user.last_name}`;
  }

  public static deserialize(obj: { [key: string]: any }): User {
    return new User(obj['id'], obj['username'], obj['first_name'], obj['fathers_name'], obj['last_name'], obj['email']);
  }
}

export class Group {
  constructor(public id: number = 0, public name: string = '') {
  }
}


export class UserPayment {
  constructor(public id: number = 0, public user: User = new User(), date_start: string, date_end: string) {
  }
}
